// extracted by mini-css-extract-plugin
export default {"header":"Header_header__Lhnr8","title":"Header_title__rzFD1","iconsContainer":"Header_iconsContainer__-kTo4","icon":"Header_icon__V9Fg3"};